export default __webpack_public_path__ + "e9f5aaf547f165386cd313b995dddd8e.woff2";